import React, { Component } from 'react'
import './LabelledText.css'

class LabelledText extends Component {
  render () {
    return (
      <div className='LabelledText'>
        <p className='label'>{this.props.label}</p>
        <p className='lead'>{this.props.text}</p>
      </div>
    )
  }
}

export default LabelledText



// WEBPACK FOOTER //
// ./src/components/App/LabelledText.js